const startDate = new Date();
startDate.setHours(startDate.getHours() - 1);

const endDate = new Date();

export const dateRange = {
  since: startDate,
  until: endDate,
};
